import React from 'react';
import './style.css'

const Scrollbar = () => {
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return(
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    <li><button type="button" onClick={scrollToTop} aria-label="Retour en haut"><i className="fa fa-arrow-up"></i></button></li>
                </ul>
            </div>
        </div>
        
    )
}

export default Scrollbar;
